import { Injectable } from '@angular/core';
import { Subject } from 'rxjs/Subject';


@Injectable({
  providedIn: 'root'
})
/*
* El servicio ayuda a comunicarse entre ToastComponent y AdminComponent.
*
*/
export class ToastCommunicationService {
  // Observable string sources
  private positionSource = new Subject<string>();

  // Observable string streams
  position$ = this.positionSource.asObservable();

  setPosition(position: string) {
      this.positionSource.next(position);
  }
}
